<app-basic-button 
    class="back-button" 
    [title]="'Back'" 
    [type]="buttonTypes.Primary" 
    (click)="backButton()">
</app-basic-button>